const doc = [({"zh_cn":({"adminComponentHotelFilter":({"addFilter":"添加筛选条件", "hotelFilterTitle":"筛选条件设置"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;